import React from "react";
import {formatMoney} from "@/utils/MoneyUtils";
import {FulfillmentType} from "@/data/entities/restaurant";
import {FormattedMessage} from "react-intl";
import {twJoin} from "tailwind-merge";

type Props = {
    fulfillmentType: FulfillmentType,
    price: string,
    active: boolean,
};

const PriceTag = ({fulfillmentType, price, active}: Props) => {
    return (
        <data
            className={twJoin(
                "flex flex-col items-start justify-start",
                active
                    ? "order-first"
                    : "opacity-60",
            )}
        >
            <span className={"text-[90%] opacity-80"}>
                <FormattedMessage id={fulfillmentType}/>
            </span>
            <span className={twJoin("font-bold", active ? "text-[120%]" : "text-[90%]")}>
                {formatMoney(Number(price))}
            </span>
        </data>
    );
};

export default PriceTag;